import { Box, styled } from "@mui/material";

export const FleetPageContainer = styled(Box, {
  name: "FleetPageContainer",
})({
  display: "flex",
});
